import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    IconButton,
    Box,
    Chip,
    Avatar
} from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import './UserListItem.css';

const UserListItem = ({
    name,
    email,
    roles,
    onEdit,
    onDelete,
    onRoleClick,
    onResetPassword
}) => {
    const getInitials = (name) => {
        if (!name) return "?";
        return name
            .split(' ')
            .map(word => word[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    };

    return (
        <Card className="user-list-item">
            <Box className="user-info">
                <Avatar className="user-avatar">
                    {getInitials(name)}
                </Avatar>
                <CardContent className="user-details">
                    <Typography variant="h6" component="h3" className="user-name">
                        {name}
                    </Typography>
                    <Typography variant="body2" className="user-email">
                        {email}
                    </Typography>
                    <Box className="user-roles">
                        {(roles || []).map((role, index) => (
                            <Chip
                                key={index}
                                label={role}
                                color="primary"
                                variant="outlined"
                                size="small"
                                className="role-chip"
                            />
                        ))}
                    </Box>
                </CardContent>
            </Box>

            <div className="user-actions">
                <IconButton onClick={onEdit} size="small" style={{ color: '#fff' }}>
                    <Edit />
                </IconButton>
                <IconButton onClick={onDelete} color="error" size="small">
                    <Delete />
                </IconButton>
                <IconButton onClick={onResetPassword} size="small" style={{ color: '#999', marginLeft: 8 }} title="Resetar senha">
                    <RestartAltIcon fontSize="small" />
                </IconButton>
            </div>
        </Card>
    );
};

export default UserListItem; 